import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

interface FloorStageView {
  panoramicButtonTitle: string
}

interface PackageOptions {
  floorplanOption: string
  facade: string
  facadeColor: string
  internalTheme: string
  internalColorScheme: string
}

export interface Filter {
  blockDropdownLabel: string
  levelDropdownLabel: string
  precinctDropdownLabel: string
  stageDropdownLabel: string
  toggleText: string
}

export interface Shortlist {
  qrCodeScanLabel: string
  includeLabel: string
  agentLabel: string
}

export interface PropertySidePanel extends PackageOptions {
  levelStagePrefix: string
  packageListTitle: string
  floorplanOption: string
  facade: string
  facadeColor: string
  internalTheme: string
  internalColorScheme: string
}

export interface PropertyView {
  panoramicButtonTitle: string
  loadExternalLinkButtonTitle: string
  closeExternalLinkButtonTitle: string
}

export interface WhiteLabel {
  filter: Filter
  shortlist: Shortlist
  propertySidePanel: PropertySidePanel
  propertyView: PropertyView
  floorStageView: FloorStageView
}

interface WhiteLabelAPIData {
  showcase: WhiteLabel
}

type RequestType = {
  projectName: string
}

const VERSION = 'v3'

export const whiteLabelApi = createApi({
  reducerPath: 'whiteLabelApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getWhiteLabels: builder.query<ApiResponse<WhiteLabelAPIData>, RequestType>({
      query: (params: RequestType) => ({
        url: `/${VERSION}/${params.projectName}/white-labels`,
        method: 'get',
        params: {
          app: 'showcase',
        },
      }),
    }),
  }),
})

export const selectFromWhiteLabelResult = ({
  data,
  isLoading,
  isError,
  status,
  error,
}: UseQueryStateResult<any, any>): {
  whiteLabelData: WhiteLabel
  isLoaded: boolean
  isError: boolean
  status: string
  errorStatus: number
} => ({
  whiteLabelData: data?.data?.showcase || {},
  isLoaded: !isLoading,
  isError,
  status,
  errorStatus: error?.status,
})

export const { useGetWhiteLabelsQuery } = whiteLabelApi
